import { render, staticRenderFns } from "./BatchesOpenReport.vue?vue&type=template&id=59e8e4ef"
import script from "./BatchesOpenReport.vue?vue&type=script&lang=js"
export * from "./BatchesOpenReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports